import { render, staticRenderFns } from "./LisCompras.vue?vue&type=template&id=38a648c0&scoped=true"
import script from "./LisCompras.vue?vue&type=script&lang=js"
export * from "./LisCompras.vue?vue&type=script&lang=js"
import style0 from "./LisCompras.vue?vue&type=style&index=0&id=38a648c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a648c0",
  null
  
)

export default component.exports